import { render, staticRenderFns } from "./GroupListScreen.vue?vue&type=template&id=0ec5e984"
import script from "./GroupListScreen.vue?vue&type=script&lang=js"
export * from "./GroupListScreen.vue?vue&type=script&lang=js"
import style0 from "./GroupListScreen.vue?vue&type=style&index=0&id=0ec5e984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports